// extracted by mini-css-extract-plugin
module.exports = {"cls1":"NavMain-StyledNavbar-module--cls1--3GekH","cls2":"NavMain-StyledNavbar-module--cls2--2pVZv NavMain-StyledNavbar-module--cls1--3GekH"};